import React, { useState } from "react";
import { formatDate } from "../../../Utils/utils";
import { formatDateString } from "../../../Customer/Utils";
import ModalComponent from "../../../Appoinment/component/ModalComponent";
import AddPregnancy from "../AddForms/AddPregnancy";
import { useLocation } from "react-router-dom";

const Pregnancy = ({ PregnancyData, refetchPregnancy }) => {
  const [pregnancyModal, setPregnancyModal] = useState(false);
  const PregnancyHistoryData = PregnancyData?.data || [];
  const location = useLocation();

  const { consultantId } = location.state || {};

  const handleAdd = () => {
    setPregnancyModal(true);
  };
  console.log(PregnancyHistoryData);
  return (
    <div>
      {consultantId && (
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-violet d-flex align-items-center"
          onClick={() => handleAdd()}
        >
          <span className="material-symbols-outlined me-2">add</span>
          Add Pregnancy
        </button>
      </div>
       )}
      <div>
        {PregnancyHistoryData?.length > 0 ? (
          PregnancyHistoryData.map((p: any, index: any) => (
            <div key={index} className="card p-3 mt-2 mb-3">
              <div>
                <span>{formatDateString(p.createdAt)}</span>
              </div>
              <div className="mt-2">
                <span
                  className="rounded p-1 fw-500 f-20"
                  style={{
                    backgroundColor: "rgba(46, 162, 134, 0.2)",
                    color: "#2EA286",
                  }}
                >
                  {p.type}
                </span>
              </div>
              {p.type === "Before Delivery" && (
                <div className="d-flex gap-4 mt-3">
                  <div className="d-flex flex-column gap-2">
                    <span className="fw-500 f-20 fw-bold">
                      Last Menstrual Period
                    </span>
                    <span className="d-flex align-items-center gap-2">
                      <span
                        className="material-symbols-outlined fw-bold"
                        style={{ color: "#007AFF" }}
                      >
                        calendar_clock
                      </span>
                      {formatDateString(p?.lastMenstrualPeriod)}
                    </span>
                  </div>
                  <div className="d-flex flex-column gap-2">
                    <span className="fw-500 f-20 fw-bold">
                      Expected Delivery Date
                    </span>
                    <span className="d-flex align-items-center gap-2">
                      <span
                        className="material-symbols-outlined fw-bold"
                        style={{ color: "#007AFF" }}
                      >
                        calendar_clock
                      </span>
                      {formatDateString(p?.expectedDeliveryDate)}
                    </span>
                  </div>
                </div>
              )}
              {p.type === "After Delivery" && (
                <>
                  <div className="d-flex gap-4 mt-3">
                    <div className="d-flex flex-column gap-2">
                      <span className="fw-500 f-20 fw-bold">
                        Actual Delivery Date
                      </span>
                      <span className="d-flex align-items-center gap-2">
                        <span
                          className="material-symbols-outlined fw-bold"
                          style={{ color: "#007AFF" }}
                        >
                          calendar_clock
                        </span>
                        {formatDateString(p?.actualDeliveryDate)}
                      </span>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <span className="fw-500 f-20 fw-bold">
                        Actual Delivery Time
                      </span>
                      <span className="d-flex align-items-center gap-2">
                        <span
                          className="material-symbols-outlined fw-bold"
                          style={{ color: "#007AFF" }}
                        >
                          history
                        </span>
                        {p?.actualDeliveryTime}
                      </span>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <span className="fw-500 f-20 fw-bold">Baby Gender</span>
                      <span className="d-flex align-items-center gap-2">
                        <span
                          className="material-symbols-outlined fw-bold"
                          style={{ color: "#007AFF" }}
                        >
                          child_care
                        </span>
                        {p?.babyGender}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 mt-3">
                    <span className="fw-500 f-20 fw-bold">Delivery Type</span>
                    <span className="d-flex align-items-center gap-2">
                      <span
                        className="material-symbols-outlined fw-bold"
                        style={{ color: "#007AFF" }}
                      >
                        pregnant_woman
                      </span>
                      {p?.deliveryMethod}
                    </span>
                  </div>
                </>
              )}
              {(p.notesBeforeDelivery || p.notesAfterDelivery) && (
                <div
                  className="rounded p-3 mt-3"
                  style={{ backgroundColor: "#EBEBEB" }}
                >
                  <span className="f-21 fw-500">Notes</span>
                  <div className="mt-1">
                    <span className="f-16 fw-400" style={{ color: "#696969" }}>
                      {p.notesBeforeDelivery || p.notesAfterDelivery}
                    </span>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "60vh" }}
          >
            <span className="fw-bold">No Pregnancy available !</span>
          </div>
        )}
      </div>
      <ModalComponent
        title="Add Pregnancy"
        show={pregnancyModal}
        body={
          <AddPregnancy
            refetch={refetchPregnancy}
            setPregnancyModal={setPregnancyModal}
          />
        }
        onClose={() => setPregnancyModal(false)}
      />
    </div>
  );
};

export default Pregnancy;
